import { render, staticRenderFns } from "./BsiCoupons.vue?vue&type=template&id=0076484b"
import script from "./BsiCoupons.vue?vue&type=script&lang=js"
export * from "./BsiCoupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports